import axiosClient from "../axiosInstance";

const baseURL = axiosClient.defaults.baseURL;

export const getAiStatus = () =>
  axiosClient.get("/ai/status").then((response) => response.data);

/**
 * Stream an AI chat completion as NDJSON lines.
 * onEvent receives one parsed object per line:
 * {type:"tool_start",name,input} | {type:"text_delta",text} |
 * {type:"done",usage} | {type:"error",message}
 */
export async function streamAiQuery({ messages, token, onEvent, signal }) {
  const response = await fetch(`${baseURL}/ai/query`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ messages }),
    signal,
  });

  if (!response.ok) {
    let body = {};
    try {
      body = await response.json();
    } catch {
      // Non-JSON error body - fall through to the generic message.
    }
    const error = new Error(
      body.message || `AI request failed (${response.status})`,
    );
    error.status = response.status;
    error.code = body.code;
    throw error;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  const processLine = (line) => {
    const trimmed = line.trim();
    if (trimmed) onEvent(JSON.parse(trimmed));
  };

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let newlineIndex;
    while ((newlineIndex = buffer.indexOf("\n")) >= 0) {
      const line = buffer.slice(0, newlineIndex);
      buffer = buffer.slice(newlineIndex + 1);
      processLine(line);
    }
  }

  buffer += decoder.decode();
  if (buffer.trim()) processLine(buffer);
}
